import request from './common/request'
import qs from 'qs'

import { SYSTEM_MERCHANT_ROLE_URL } from './urls'

// 列表
async function list () {
  return request(
    {
      url: SYSTEM_MERCHANT_ROLE_URL,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: SYSTEM_MERCHANT_ROLE_URL,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ROLE_URL}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 启用
async function enable (roleId) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ROLE_URL}/${roleId}/enable`,
      method: 'PUT'
    }
  )
}

// 禁用
async function disable (roleId) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ROLE_URL}/${roleId}/disable`,
      method: 'PUT'
    }
  )
}

/**
 * 通过角色ID获取权限列表
 * @param {Int} roleId    角色ID
 * @return
 */
async function getRolePermissions (roleId) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ROLE_URL}/${roleId}/permissions`,
      method: 'GET'
    }
  )
}

/**
 * 为角色添加权限
 * @param {Object} params     请求参数
 * @return
 */
async function addRolePermissions (params) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ROLE_URL}/${params.roleId}/permissions`,
      method: 'POST',
      data: qs.stringify({
        permissionId: params.permissionId
      })
    }
  )
}

/**
 * 为角色删除权限
 * @param {*} params    请求参数
 * @return
 */
async function removeRolePermissions (params) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ROLE_URL}/${params.roleId}/permissions/${params.permissionId}`,
      method: 'DELETE'
    }
  )
}

export default {
  list,
  insert,
  update,
  enable,
  disable,
  getRolePermissions,
  addRolePermissions,
  removeRolePermissions
}



// WEBPACK FOOTER //
// ./src/api/merchant-role.js